module.exports = __webpack_public_path__ + "img/8.a9e1a70f.png";